"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _pickers = require("@material-ui/pickers");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _customField = _interopRequireDefault(require("../../../../_common/formik/customField"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

var BusinessHours = function BusinessHours(_ref) {
  var value = _ref.value,
      businessHoursTemporarilyAffected = _ref.businessHoursTemporarilyAffected,
      setFieldValue = _ref.setFieldValue;
  console.log("biz hours render", value);

  var handleBusinessHoursChange = function handleBusinessHoursChange(key, date) {
    if (date) {
      console.log("handleBusinessHoursChange", date);
      setFieldValue('businessHours', _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, key, "".concat(date.getHours(), ":").concat(date.getMinutes()))));
    }
  }; // Sends a fake change event to Formik whenever a row is toggled. Defaults to 9am open and 5pm close


  var onRowChange = function onRowChange(event) {
    var _event$target = event.target,
        day = _event$target.name,
        checked = _event$target.checked;

    var newValues = _objectSpread({}, value);

    if (checked) {
      newValues[_getOpenKey(day)] = "9:0";
      newValues[_getCloseKey(day)] = "17:0";
    } else {
      delete newValues[_getOpenKey(day)];
      delete newValues[_getCloseKey(day)];
    }

    setFieldValue('businessHours', newValues);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "location-edit-business-hours-container"
  }, DAYS.map(function (day, index) {
    var rowChecked = _isRowChecked(value, day);

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "flex location-edit-business-hours-row",
      key: "bizhrs-" + index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex flex1"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex center"
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      name: day,
      color: "primary",
      checked: rowChecked,
      onChange: onRowChange
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "location-details-business-hours-label flex center"
    }, day)), rowChecked && /*#__PURE__*/_react.default.createElement("div", {
      className: "flex align-items-center"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardTimePicker, {
      margin: "normal",
      id: "location-details-business-hours-" + day + "-open",
      value: _getOpenDate(value, day),
      onChange: handleBusinessHoursChange.bind(null, _getOpenKey(day)),
      KeyboardButtonProps: {
        'aria-label': 'change time'
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "location-details-business-hours-from flex center"
    }, "to"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardTimePicker, {
      margin: "normal",
      id: "location-details-business-hours-" + day + "-close",
      value: _getCloseDate(value, day),
      onChange: handleBusinessHoursChange.bind(null, _getCloseKey(day)),
      KeyboardButtonProps: {
        'aria-label': 'change time'
      }
    }))));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop15"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _Checkbox.default,
    name: "businessHoursTemporarilyAffected",
    type: "checkbox",
    color: "primary"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-label flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Business Hours are temporarily affected"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop10"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "businessHoursTemporaryMessage",
    label: "Temporary Business Hours Reason",
    placeholder: "COVID-19",
    helperText: "Please tell us why these business hours are temporary.",
    inputProps: {
      maxLength: 500
    },
    fullWidth: true
  }))));
};

var _getOpenKey = function _getOpenKey(day) {
  return "".concat(day.toLowerCase(), "Open");
};

var _getCloseKey = function _getCloseKey(day) {
  return "".concat(day.toLowerCase(), "Close");
};

var _isRowChecked = function _isRowChecked(businessHoursValues, day) {
  return !!(businessHoursValues && businessHoursValues[_getOpenKey(day)]);
};

var _getOpenDate = function _getOpenDate(businessHoursValues, day) {
  return _getDateForTime(businessHoursValues[_getOpenKey(day)]);
};

var _getCloseDate = function _getCloseDate(businessHoursValues, day) {
  return _getDateForTime(businessHoursValues[_getCloseKey(day)]);
};

var _getDateForTime = function _getDateForTime(time) {
  var date = new Date();
  var timeParts = time.split(":");
  var hr = timeParts[0];
  var min = timeParts[1];
  date.setHours(hr);
  date.setMinutes(min);
  return date;
};

var _default = BusinessHours;
exports.default = _default;